// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5dd42e85","232":"a33e001a","237":"c3b4915c","513":"956bc178","526":"a48582da","545":"c4575bc1","872":"6827a6db"}[chunkId] + ".chunk.js";
};